<template>
  <div v-if="attached && closable" class="d-chips">
    <component
      :is="newTag"
      class="d-chip"
      :class="[`chip-${color}`, size, roundedClass]"
    >
      <span :class="{ 'has-ellipsis': ellipsis }">
        <slot />
      </span>
    </component>
    <a
      class="d-chip is-delete"
      role="button"
      :aria-label="ariaCloseLabel"
      :tabindex="tabstop ? 0 : false"
      :disabled="disabled"
      :class="[size, roundedClass]"
      @click="close()"
      @keyup.delete.prevent="close()"
    />
  </div>
  <component
    :is="newTag"
    v-else
    class="d-chip"
    :class="[`chip-${color}`, roundedClass, size]"
  >
    <span :class="{ 'ellipsis': ellipsis }">
      <slot />
    </span>

    <a
      v-if="closable"
      :tag="newTag"
      :href="href"
      role="button"
      :aria-label="ariaCloseLabel"
      class="delete"
      :disabled="disabled"
      :tabindex="tabstop ? 0 : false"
      @click="close()"
      @keyup.delete.prevent="close()"
    />
  </component>
</template>

<script>
  import { defineComponent } from 'vue';
  import GeneralMixin from '../../../utils/mixins/generalMixin';

  /**
   * @displayName Chip
   */
  export default defineComponent({
    name: 'DChip',
    mixins: [GeneralMixin],
    props: {
      attached: Boolean,
      href: String,
      closable: Boolean,
      disabled: Boolean,
      ellipsis: Boolean,
      label: Boolean,
      tabstop: {
        type: Boolean,
        default: true,
      },

      ariaCloseLabel: {
        type: String,
        default: 'Close',
      },

      color: {
        type: String,
        default: 'primary-500',
      },

      /**
       * Controls the font size and padding size of the button
       * @parameters sm, md, lg, xl
       */
      size: {
        type: String,
        default: 'md',
        validator: (value) => ['sm', 'md', 'lg', 'xl'].includes(value),
      },
    },

    computed: {
      newTag() {
        return this.href ? 'a' : 'div';
      },

      roundedClass() {
        return this.label ? 'rounded' : 'rounded-full';
      },
    },

    methods: {
      /**
       * Emit close event when delete button is clicked
       * or delete key is pressed.
       */
      close() {
        if (this.disabled) return;
        this.$emit('close');
      },
    },
  });
</script>